<template>
  <div class="basic_wrap">
    <van-row style="margin-top: 90px">
      <van-col span="24" style="text-align: center">
        <img src="../images/startpage/Logo.png" alt="" style="width: 230px" />
        <p class="webName">ameican filmmork et.com</p>
      </van-col>
    </van-row>
    <van-row style="padding-top: 25px">
      <van-col span="24">
        <div class="countBg">
          <div class="countBorder">
            <img
              src="../images/startpage/count.png"
              style="width: 145px; padding-top: 10px"
            />
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Col, Row } from "vant";
Vue.use(Row).use(Col);

export default {
  name: "login",
  data() {
    return {
      time: 60,
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.basic_wrap {
  background: url(../images/startpage/splashBg.png);
  background-size: 100% 100%;
  height: 100vh;
}

.webName {
  font-size: 26px;
  color: #ffffff;
  text-align: center;
  padding-top: 20px;
}

.countBg {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.countBorder {
  background: url(../images/startpage/countBorder.png);
  background-size: 100% 100%;
  height: 300px;
  width: 300px;
  position: relative;
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
